<template>
  <div class="feedback-list">
    <div v-if="isLoading" class="loading">&nbsp;</div>
    <div class="dashboard">
      <DashboardTitleSearch
        :property-name="property_name"
        :property-id="property_id"
      />
      <h2 class="bold">CUSTOMER JOURNEY</h2>
      <div v-if="customerJourney.data">
        <!-- <div class="customer-journey-column">
          <div class="dashboard-box-header">
            <h2>Brand Awareness</h2>
          </div>
          <div class="dashboard-box-medium">
            <div class="category-body">
              <span class="box-header">
                Social Awareness
              </span>
              <span
                class="box-number-empty">
                Coming Soon
              </span>
            </div>
          </div>
        </div> -->

        <div class="customer-journey-column">
          <div class="dashboard-box-header">
            <h2>Browse</h2>
          </div>
          <div
            v-for="(category, index) in getBrowse()"
            :key="category.id"
            :class="[
              'dashboard-box-medium',
              getSentimentClass(category.sentiment)
            ]"
          >
            <div class="number-box-left big-digits-number-black">
              {{ index + 1 }}
              <br />
            </div>
            <div class="category-body">
              <router-link
                :to="{
                  name: 'dashboardFeedbackByCustomerJourney',
                  params: {
                    id: property_id,
                    customer_journey_cat_id: category.id
                  },
                  query: {
                    rank: index + 1,
                    sat_percent: Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }
                }"
              >
                <span class="box-header">
                  {{ category.name }}
                </span>
              </router-link>
              <div v-if="category.four_week_count">
                <span class="box-number"
                  >{{
                    Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }}%</span
                >
                <span class="box-number-label">Satisfaction Impact</span> <br />
                <span class="box-number">{{
                  category.four_weeks_nps_score
                }}</span>
                <span class="box-number-label">Experience Score</span>
                <br />
              </div>
              <div v-if="!category.four_week_count" class="box-number-empty">
                No Feedback
              </div>
              <div v-if="category.sentiment === 1" class="sentiment-icons">
                <img src="../assets/mad.png" />
              </div>
              <div v-else-if="category.sentiment === 5" class="sentiment-icons">
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="category.sentiment === 10"
                class="sentiment-icons"
              >
                <img src="../assets/happy.png" />
              </div>
            </div>
          </div>
        </div>

        <div class="customer-journey-column">
          <div class="dashboard-box-header">
            <h2>Purchase</h2>
          </div>
          <div
            v-for="(category, index) in getPurchase()"
            :key="category.id"
            :class="[
              'dashboard-box-medium',
              getSentimentClass(category.sentiment)
            ]"
          >
            <div class="number-box-left big-digits-number-black">
              {{ index + 1 }}
              <br />
            </div>
            <div class="category-body">
              <router-link
                :to="{
                  name: 'dashboardFeedbackByCustomerJourney',
                  params: {
                    id: property_id,
                    customer_journey_cat_id: category.id
                  },
                  query: {
                    rank: index + 1,
                    sat_percent: Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }
                }"
              >
                <span class="box-header">
                  {{ category.name }}
                </span>
              </router-link>
              <div v-if="category.four_week_count">
                <span class="box-number"
                  >{{
                    Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }}%</span
                >
                <span class="box-number-label">Satisfaction Impact</span> <br />
                <span class="box-number">{{
                  category.four_weeks_nps_score
                }}</span>
                <span class="box-number-label">Experience Score</span>
                <br />
              </div>
              <div v-if="category.sentiment === 1" class="sentiment-icons">
                <img src="../assets/mad.png" />
              </div>
              <div v-else-if="category.sentiment === 5" class="sentiment-icons">
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="category.sentiment === 10"
                class="sentiment-icons"
              >
                <img src="../assets/happy.png" />
              </div>
              <div v-if="!category.four_week_count" class="box-number-empty">
                No Feedback
              </div>
            </div>
          </div>
        </div>
        <div class="customer-journey-column">
          <div class="dashboard-box-header">
            <h2>Post Purchase</h2>
          </div>
          <div
            v-for="(category, index) in getPostPurchase()"
            :key="category.id"
            :class="[
              'dashboard-box-medium',
              getSentimentClass(category.sentiment)
            ]"
          >
            <div class="number-box-left big-digits-number-black">
              {{ index + 1 }}
              <br />
            </div>
            <div class="category-body">
              <router-link
                :to="{
                  name: 'dashboardFeedbackByCustomerJourney',
                  params: {
                    id: property_id,
                    customer_journey_cat_id: category.id
                  },
                  query: {
                    rank: index + 1,
                    sat_percent: Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }
                }"
              >
                <span class="box-header">
                  {{ category.name }}
                </span>
              </router-link>
              <div v-if="category.four_week_count">
                <span class="box-number"
                  >{{
                    Math.round(
                      (category.action_score / category.action_score_total) *
                        100
                    )
                  }}%</span
                >
                <span class="box-number-label">Satisfaction Impact</span> <br />
                <span class="box-number">{{
                  category.four_weeks_nps_score
                }}</span>
                <span class="box-number-label">Experience Score</span>
                <br />
              </div>
              <div v-if="category.sentiment === 1" class="sentiment-icons">
                <img src="../assets/mad.png" />
              </div>
              <div v-else-if="category.sentiment === 5" class="sentiment-icons">
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="category.sentiment === 10"
                class="sentiment-icons"
              >
                <img src="../assets/happy.png" />
              </div>
              <div v-if="!category.four_week_count" class="box-number-empty">
                No Feedback
              </div>
            </div>
          </div>
        </div>

        <div v-if="npsDatas.nps_overall" class="customer-journey-column">
          <div class="dashboard-box-header">
            <h2>Repeat Purchase</h2>
          </div>
          <div
            :class="[
              'dashboard-box-medium',
              getSentimentClass(
                npsDatas.nps_overall.sentiment_score_four_weeks_sentiment
              )
            ]"
          >
            <div class="category-body">
              <span class="box-header">
                Experience Score
              </span>
              <div>
                <span class="box-number">{{
                  parseInt(
                    npsDatas.nps_overall.sentiment_score_four_weeks_overall
                  )
                }}</span>
                <span class="box-number-label">Experience Score</span><br />
                <span class="box-footer"
                  >{{ npsDatas.nps_overall.sentiment_score_diff }}% change</span
                >
              </div>
              <div
                v-if="
                  npsDatas.nps_overall.sentiment_score_four_weeks_sentiment ===
                    1
                "
                class="sentiment-icons"
              >
                <img src="../assets/mad.png" />
              </div>
              <div
                v-else-if="
                  npsDatas.nps_overall.sentiment_score_four_weeks_sentiment ===
                    5
                "
                class="sentiment-icons"
              >
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="
                  npsDatas.nps_overall.sentiment_score_four_weeks_sentiment ===
                    10
                "
                class="sentiment-icons"
              >
                <img src="../assets/happy.png" />
              </div>
            </div>
          </div>

          <div
            :class="[
              'dashboard-box-medium',
              getSentimentClass(npsDatas.nps_overall.nps_four_weeks_sentiment)
            ]"
          >
            <div class="category-body">
              <span class="box-header">
                NPS Score
              </span>
              <div>
                <span class="box-number">{{
                  parseInt(npsDatas.nps_overall.nps_classic_four_weeks_overall)
                }}</span>
                <span class="box-number-label">NPS Score</span><br />
                <span class="box-footer"
                  >{{ npsDatas.nps_overall.nps_classic_diff }}% change</span
                >
              </div>
              <div
                v-if="npsDatas.nps_overall.nps_four_weeks_sentiment === 1"
                class="sentiment-icons"
              >
                <img src="../assets/mad.png" />
              </div>
              <div
                v-else-if="npsDatas.nps_overall.nps_four_weeks_sentiment === 5"
                class="sentiment-icons"
              >
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="npsDatas.nps_overall.nps_four_weeks_sentiment === 10"
                class="sentiment-icons"
              >
                <img src="../assets/happy.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import api from "@/api/index";
const apiService = new api.APIServiceFeedbackDashboard();

export default {
  name: "DashboardFeedbackCustomerJourney",
  components: {
    DashboardTitleSearch
  },
  data() {
    return {
      isLoading: true,
      customerJourney: [],
      npsDatas: {},
      property_id: this.$route.params.id,
      property_name: this.$route.params.property_name
    };
  },
  created() {
    this.isLoading = true;
    this.getPropertyFeedbackCustomerJourney();
    this.getPropertyFeedbackNPS();
  },
  methods: {
    getPropertyFeedbackCustomerJourney: function() {
      apiService
        .getPropertyFeedbackCustomerJourney(this.$route.params.id)
        .then(data => {
          this.customerJourney = data;
          console.log(this.customerJourney);
          this.isLoading = false;
        });
    },
    getPropertyFeedbackNPS: function() {
      apiService.getPropertyFeedbackNPS(this.$route.params.id).then(data => {
        this.npsDatas = data;
      });
    },
    getCategory: function(id) {
      var found = this.customerJourney.data.find(function(element) {
        return element.id > id;
      });
      return found;
    },
    getBrowse: function() {
      //customer_journey_channel.name= "browse"
      var data = this.customerJourney.data.browse;

      return data;
    },
    getPurchase: function() {
      //customer_journey_channel.id = "purchase"
      // var data = this.customerJourney.data.filter(category => category.id > 9 && category.id <= 19);
      var data = this.customerJourney.data.purchase;
      return data;
    },
    getPostPurchase: function() {
      //customer_journey_channel.id = "post_purchase"
      // var data = this.customerJourney.data.filter(category => category.id > 19);
      var data = this.customerJourney.data.post_purchase;

      return data;
    },
    getSentimentClass(score) {
      var sentimentColor = "";
      if (score === 1) {
        sentimentColor = "negative-color";
      } else if (score === 5) {
        sentimentColor = "neutral-color";
      } else if (score === 10) {
        sentimentColor = "positive-color";
      } else {
        sentimentColor = "empty-color";
      }

      return sentimentColor;
    }
  }
};
</script>

<style scoped>
@lost gutter 15px;
h2 {
  font-size: 18px;
}
.dashboard {
  lost-utility: clearfix;
}
.customer-journey-column {
  lost-column: 1/4;
}
.dashboard-box-header {
  height: 44px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding-top: 6px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.dashboard-box-header h2 {
  font-weight: bold;
  font-size: 24px;
}
.dashboard-box-medium {
  height: 143px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #d5e0ec;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding: 6px 3px 0 3px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.number-box-left {
  padding: 3px 10px 0 5px;
  width: 40px;
  height: 100px;
  float: left;
  clear: none;
}
.big-digits-number-black {
  font-size: 28px;
  font-weight: bold;
}
.category-body {
  display: block;
  width: 100%;
  margin-bottom: 16px;
  margin-left: 5px;
  padding: 4px;
}
.dashboard-box-medium .box-header {
  font-size: 20px;
  display: block;
  font-weight: bold;
  text-align: left;
}
.category-body a {
  color: #2c3e50;
}
.box-number {
  font-size: 22px;
  width: 48px;
  text-align: right;
  float: left;
}
.box-number-label {
  float: left;
  padding-left: 5px;
}
.box-number-empty {
  display: block;
  padding-top: 20px;
  text-align: center;
}
.box-footer {
  font-size: 14px;
  display: block;
}
.sentiment-icons2 img {
  width: 30px;
  float: right;
  top: 10px;
  right: 7px;
}
.sentiment-icons {
  width: 100%;
  text-align: center;
  display: block;
}
.sentiment-icons img {
  width: 30px;
}
.positive-color {
  background-color: #33a878;
}
.negative-color {
  background-color: #df6358;
}
.neutral-color {
  background-color: #cfd1d3;
}
.empty-color {
  background-color: #ffffff;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media (max-width: 1191px) {
  .dashboard-box-header h2 {
    font-size: 20px;
  }
  .dashboard-box-medium .box-header {
    font-size: 16px;
  }
  .box-number {
    font-size: 17px;
    font-weight: bold;
    width: 40px;
  }
  .box-number-label {
    font-size: 14px;
  }
}
@media (max-width: 1058px) {
  .customer-journey-column {
    lost-column: 1/3;
  }
  .dashboard-box-medium .box-header {
    font-size: 20px;
  }
  .box-number {
    font-size: 22px;
    width: 52px;
  }
  .box-number-label {
    font-size: 18px;
  }
}
@media (max-width: 900px) {
  .customer-journey-column {
    lost-column: 1/2;
  }
}
@media (max-width: 640px) {
  .customer-journey-column {
    lost-column: 1/1;
  }
}
</style>
